export type RegionMode = "global" | "eea_only";
export const REGION_MODES = ["global", "eea_only"] as const;

/**
 * EEA + UK + Switzerland. These two-letter country codes come straight from
 * Cloudflare's `cf-ipcountry` header.
 */
export const EEA_UK_CH: ReadonlySet<string> = new Set([
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR",
  "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL",
  "PL", "PT", "RO", "SK", "SI", "ES", "SE",
  "IS", "LI", "NO",
  "GB", "CH",
]);

export function isConsentRequiredRegion(countryCode: string | null | undefined): boolean {
  if (!countryCode) return true;
  return EEA_UK_CH.has(countryCode.toUpperCase());
}
